import type {Color} from "../colorObject";


import globalsObject, {translate} from "../globalsObject";
import type {ColorCodeFromDB} from "../databaseInterfaceClasses";



export type ColorCodeAlias = {
    colorCode,
    alias
}

export class ColorCodeAliasTranslator{

    private static getAlias(colorCode, colorCodeAliases:ColorCodeAlias[]) {
        const alias = colorCodeAliases.filter(a=>a.colorCode === colorCode).pop();
        return typeof alias === "undefined" ? colorCode : alias.alias;
    }

    private static getColorCodeAliases(design) {
        const resource = globalsObject.resourceManager.getResourceByName("produkt.php");
        if(typeof(resource.data.colorcodeAliases) === "undefined") {
            return [];
        }
        const sternchen = resource.data.colorcodeAliases["*"] || [];
        const fromDesign = resource.data.colorcodeAliases[design] ||[];
        return sternchen.concat(fromDesign);
    }

    public static getColorcodesWithAlias(alias, design) {
        const aliases = ColorCodeAliasTranslator.getColorCodeAliases(design);
        return aliases.filter(a=>a.alias === alias);
    }

    public static setAliases(colorObjects:Array<Color|ColorCodeFromDB>, design):Array<Color|ColorCodeFromDB> {
        return colorObjects.map(function(color) {
            color.colorCodeToDisplay = ColorCodeAliasTranslator.getAlias(color.colorCode, ColorCodeAliasTranslator.getColorCodeAliases(design));
            if(color.colorCodeToDisplay !== color.colorCode) {
                color.farbname = translate("ColorCode" + color.colorCodeToDisplay, color.colorCodeToDisplay);
            }
            return color;
        })
    }

}
